export var theme = {
    tab: {
        minWidth: '120px',
        maxWidth: '200px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        textAlign: 'center',
        '& .MuiTab-label': {
            fontSize: '0.875rem',
            lineHeight: 1.2,
        },
    },
};
